module.exports = __webpack_public_path__ + "media/images/nav-right-1cee0efd.svg";